import { GetterTree } from 'vuex'
import State from './types'
import { RootState } from '../types'

export const getters: GetterTree<State, RootState> = {
  user({ activeUser: user }) {
    return user
  },
  userLoading({ loading }) {
    return loading
  },
  errorMessage({ error, errorMessage }) {
    return error ? errorMessage : ''
  },
  isADUser({ aDUser }) {
    return aDUser
  },
}
